module.exports = __webpack_public_path__ + "static/media/iconyou.b408d187.svg";